import { render, staticRenderFns } from "./UsuarioCustomSelectBox.vue?vue&type=template&id=f69639ce&"
import script from "./UsuarioCustomSelectBox.vue?vue&type=script&lang=js&"
export * from "./UsuarioCustomSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports